import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, Activity, Users, ShieldCheck } from 'lucide-react';
import { API_URL } from '../config/api';
import './Home.css';

import HeroSlider from '../components/HeroSlider';

const Home = () => {
    const [content, setContent] = useState({});

    useEffect(() => {
        const fetchContent = async () => {
            try {
                // Local API_URL definition removed

                const response = await fetch(`${API_URL}/content`);
                const data = await response.json();

                if (data.success) {
                    setContent(data.data);
                }
            } catch (error) {
                console.error('Error fetching site content:', error);
            }
        };

        fetchContent();
    }, []);

    return (
        <div className="home-page">
            {/* Hero Slider */}
            <HeroSlider />

            {/* Intro Section */}
            <section className="section intro-section">
                <div className="container">
                    <div className="intro-grid">
                        <div className="intro-text">
                            <h2 className="section-title" style={{ textAlign: 'left' }}>
                                {content['home.intro_title'] || 'Bienvenidos a GeneCenter'}
                            </h2>
                            <p>
                                {content['home.intro_text_1'] || 'Somos un centro especializado en el diagnóstico, asesoramiento y manejo de condiciones genéticas. Nuestro compromiso es brindar atención médica de alta calidad, basada en la evidencia científica más reciente, con un enfoque profundamente humano y ético.'}
                            </p>
                            <p>
                                {content['home.intro_text_2'] || 'Entendemos que la genética es la base de la salud, y por ello ofrecemos estudios de vanguardia para ayudar a pacientes y familias a tomar decisiones informadas.'}
                            </p>
                            <Link to="/nosotros" className="btn btn-outline" style={{ marginTop: '1rem' }}>
                                Conoce más sobre nosotros <ArrowRight size={18} style={{ marginLeft: '8px' }} />
                            </Link>
                        </div>
                        <div className="intro-features">
                            <div className="feature-card">
                                <Activity className="feature-icon" size={32} />
                                <h3>{content['home.feature_1_title'] || 'Tecnología Avanzada'}</h3>
                                <p>{content['home.feature_1_desc'] || 'Utilizamos las herramientas diagnósticas más modernas (NGS, Microarreglos).'}</p>
                            </div>
                            <div className="feature-card">
                                <Users className="feature-icon" size={32} />
                                <h3>{content['home.feature_2_title'] || 'Trato Humano'}</h3>
                                <p>{content['home.feature_2_desc'] || 'Acompañamiento empático en cada paso del proceso diagnóstico.'}</p>
                            </div>
                            <div className="feature-card">
                                <ShieldCheck className="feature-icon" size={32} />
                                <h3>{content['home.feature_3_title'] || 'Confidencialidad'}</h3>
                                <p>{content['home.feature_3_desc'] || 'Manejo ético y seguro de tu información genética y médica.'}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta-section">
                <div className="container">
                    <h2>{content['home.cta_title'] || '¿Necesitas orientación genética?'}</h2>
                    <p>{content['home.cta_text'] || 'Ofrecemos consultas presenciales y en línea para tu comodidad.'}</p>
                    <div className="cta-buttons">
                        <Link to="/contacto" className="btn btn-light">
                            {content['home.cta_button_text'] || 'Consulta en Línea'}
                        </Link>
                        {content['contact.whatsapp'] && (
                            <a href={`https://wa.me/${content['contact.whatsapp']}`} target="_blank" rel="noopener noreferrer" className="btn btn-outline-light">
                                WhatsApp Directo
                            </a>
                        )}
                    </div>
                </div>
            </section>

            {/* Testimonials Preview */}
            <section className="section testimonials-section">
                <div className="container">
                    <h2 className="section-title">Lo que dicen nuestros pacientes</h2>
                    <div className="testimonials-grid">
                        <div className="testimonial-card">
                            <p className="testimonial-text">"{content['home.testimonial_1_text'] || 'Excelente atención, el doctor explicó todo con mucha claridad y paciencia. Nos sentimos muy acompañados.'}"</p>
                            <p className="testimonial-author">- {content['home.testimonial_1_author'] || 'María G.'}</p>
                        </div>
                        <div className="testimonial-card">
                            <p className="testimonial-text">"{content['home.testimonial_2_text'] || 'Gracias a los estudios pudimos tener un diagnóstico preciso para mi hijo. Altamente recomendados.'}"</p>
                            <p className="testimonial-author">- {content['home.testimonial_2_author'] || 'Roberto L.'}</p>
                        </div>
                        <div className="testimonial-card">
                            <p className="testimonial-text">"{content['home.testimonial_3_text'] || 'Profesionalismo y calidez humana. Las instalaciones son impecables y el trato es de primera.'}"</p>
                            <p className="testimonial-author">- {content['home.testimonial_3_author'] || 'Ana P.'}</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Home;
